// extracted by mini-css-extract-plugin
module.exports = {"right":"RightSide_right__3U9Uw"};